import React from 'react'
import classNames from 'classnames'
import { CircularProgress } from '@mui/material'

import { ILoanerRecord, TABLE_HEADERS } from '../../LoanerVehicles'
import ClosedLoanerRow from './ClosedLoanerRow'

import styles from '../../LoanerVehicles.module.scss'

interface IClosedLoanersTableProps {
  loaners: ILoanerRecord[]
  onReopen: (loanerId: string) => void
  onDelete: (loanerId: string) => void
  isTableHidden: boolean
  isLoading: boolean
}

const ClosedLoanersTable = ({
  loaners,
  onReopen,
  onDelete,
  isTableHidden,
  isLoading,
}: IClosedLoanersTableProps) => {
  return (
    <div
      className={classNames({
        [styles.hidden]: isTableHidden,
        [styles.closedTable]: !isTableHidden,
      })}
    >
      <div className={styles.tableContainer}>
        <table>
          <thead>
            <tr>
              {TABLE_HEADERS.map((header) => (
                <th key={header}>{header}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loaners.map((loaner) => (
              <ClosedLoanerRow
                loaner={loaner}
                onReopen={onReopen}
                onDelete={onDelete}
                key={loaner.id}
              />
            ))}

            {loaners.length === 0 && (
              <tr>
                <td colSpan={TABLE_HEADERS.length} className={styles.noData}>
                  {isLoading ? (
                    <CircularProgress color="inherit" />
                  ) : (
                    'No closed loaner vehicles.'
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ClosedLoanersTable
